export function endpointRequireToken (url) {
  if (!url) {
    return true
  }
  const reLoginRefresh = /[/]?login\/refresh[/]?/
  const reLogin = /[/]?login[/]?$/
  const reAdLogin = /[/]?login\/login-ldap[/]?/
  const reAccActivation = /[/]?administration\/activate-registered-system-user/
  const reAccTokenValidation = /[/]?administration\/validate-activation-token/
  const reAccUserActivation = /[/]?administration\/activate-system-user/
  const reRegisterAccount = /[/]?subsidy\/anonymous-user\/register-user/
  const reValidateAccount = /[/]?subsidy\/anonymous-user\/validate-user/
  // TODO
  const test = /[/]?registration\/get-entity/
  const reAccReset = /[/]?administration\/reset-password/
  const reAccTokenResetValidation = /[/]?administration\/validate-reset-token/
  const reAccUserReset = /[/]?administration\/reset-system-user/
  const reReportIssue = /[/]?issue$/
  const uploadDocument = /[/]?dms\/document\/uploaded/
  // return reLoginRefresh.test(url) || !(reLogin.test(url) || reAccRegistration.test(url))
  return !(reLogin.test(url) ||
    reAdLogin.test(url) ||
    reLoginRefresh.test(url) ||
    reAccActivation.test(url) ||
    reAccTokenValidation.test(url) ||
    reAccUserActivation.test(url) ||
    reRegisterAccount.test(url) ||
    reValidateAccount.test(url) ||
    reAccReset.test(url) ||
    test.test(url) ||
    reAccTokenResetValidation.test(url) ||
    reAccUserReset.test(url) ||
    reReportIssue.test(url) ||
    uploadDocument.test(url)
  )
}
